import { axiosWithAuth } from "helpers";

type AchFeeTemplateType = {
	companyId: string;
};
type AchFeeTemplateGetType = AchFeeTemplateType & {
	templateId: string;
};
type AchFeeTemplateEditType = AchFeeTemplateGetType & {
	data: { [key: string]: any };
};

type AriseFeeTemplateType = {
	companyId: string;
};
type AriseFeeTemplateGetType = AriseFeeTemplateType & {
	templateId: string;
};
type AriseFeeTemplateAddType = AriseFeeTemplateType & {
	data: { [key: string]: any };
};
type AriseFeeTemplateEditType = AriseFeeTemplateGetType & {
	data: { [key: string]: any };
};

export const feeTemplateService = {
	getTemplate,
	add,
	edit,
	getFeeTemplate,
	addFeeTemplate,
	updateFeeTemplate,
	isTemplateNameUnique,
	checkAchFeeTemplateName,
	checkAriseFeeTemplateName,
	achFeeTemplateGet,
	achFeeTemplatesGet,
	achFeeTemplateAdd,
	achFeeTemplateEdit,
	achFeeTemplateDelete,
	ariseFeeTemplateGet,
	ariseFeeTemplatesGet,
	ariseFeeTemplateAdd,
	ariseFeeTemplateEdit,
	ariseFeeTemplateDelete,
};

const API_URL = process.env.REACT_APP_API_URL;

function getTemplate(companyId, templateId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fields-templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function add(companyId, model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/companies/${companyId}/fields-templates`,
	};

	return axiosWithAuth(options);
}

function edit(companyId, templateId, model) {
	const options = {
		method: "PUT",
		data: model,
		url: `${API_URL}/api/companies/${companyId}/fields-templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function getFeeTemplate(companyId, templateId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fee-templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function addFeeTemplate(companyId, model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/companies/${companyId}/fee-templates`,
	};

	return axiosWithAuth(options);
}

function updateFeeTemplate(companyId, templateId, model) {
	const options = {
		method: "PUT",
		data: model,
		url: `${API_URL}/api/companies/${companyId}/fee-templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function isTemplateNameUnique(id, type, name) {
	let templateExistsModel = {
		name: name,
		type: type,
	};

	const options = {
		method: "POST",
		data: templateExistsModel,
		url: `${API_URL}/api/companies/${id}/fields-templates/check-if-exists`,
	};

	return axiosWithAuth(options);
}

function checkAchFeeTemplateName(companyId: string, templateName: string) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/ach/templates/${templateName}/check_if_in_use`,
	};

	return axiosWithAuth(options);
}

function checkAriseFeeTemplateName(companyId: string, templateName: string) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/arise/templates/${templateName}/check_if_in_use`,
	};

	return axiosWithAuth(options);
}

function achFeeTemplateGet({ companyId, templateId }: AchFeeTemplateGetType) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/ach/templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function achFeeTemplatesGet({ companyId }: AchFeeTemplateType) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/ach/templates`,
	};

	return axiosWithAuth(options);
}

function achFeeTemplateAdd(companyId: string, data: { [key: string]: any }) {
	const options = {
		method: "POST",
		data,
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/ach/templates`,
	};

	return axiosWithAuth(options);
}

function achFeeTemplateEdit({
	companyId,
	templateId,
	data,
}: AchFeeTemplateEditType) {
	const options = {
		method: "PUT",
		data,
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/ach/templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function achFeeTemplateDelete({
	companyId,
	templateId,
}: AchFeeTemplateGetType) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/ach/templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function ariseFeeTemplateGet({ companyId, templateId }: AchFeeTemplateGetType) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/arise/templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function ariseFeeTemplatesGet({ companyId }: AchFeeTemplateType) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/arise/templates`,
	};

	return axiosWithAuth(options);
}

function ariseFeeTemplateAdd({ companyId, data }: AriseFeeTemplateAddType) {
	const options = {
		method: "POST",
		data,
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/arise/templates`,
	};

	return axiosWithAuth(options);
}

function ariseFeeTemplateEdit({
	companyId,
	templateId,
	data,
}: AriseFeeTemplateEditType) {
	const options = {
		method: "PUT",
		data,
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/arise/templates/${templateId}`,
	};

	return axiosWithAuth(options);
}

function ariseFeeTemplateDelete({
	companyId,
	templateId,
}: AriseFeeTemplateGetType) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/companies/${companyId}/fee_template_types/arise/templates/${templateId}`,
	};

	return axiosWithAuth(options);
}
